namespace ekh {

    class ValidateCardType {
        private paymentForm: ng.IFormController;
        private cardNumber: string | undefined;
        private paymentOptions: any;
        private cardType: any;

        constructor(private $scope: ng.IScope,
                    private paymentsService,
                    private $q: ng.IQService
                ) {

            $scope.$watchGroup(['validateCtrl.cardType', 'validateCtrl.maskModel'], ([valCardType, maskModel]) => {
                if (!this.paymentForm || !this.paymentForm.cardNumber) {
                    return false;
                }

                if (!valCardType && this.cardNumber) {
                    this.paymentForm.cardNumber.$setValidity('wrongCreditCardNumber', false);
                    return false;
                }

                if (maskModel) {
                    this.paymentsService.checkCardNumber(this.paymentOptions, maskModel, valCardType)
                        .then(cardNumber => {
                            if (!cardNumber) {
                                this.cardType = null;
                                return $q.reject();
                            }
                        })
                        .then(() => {
                            $scope.ngModelCardNumberCtrl.$setViewValue(maskModel);
                            this.paymentForm.cardNumber.$setValidity('wrongCreditCardNumber', true);
                        })
                        .catch(() => {
                            $scope.ngModelCardNumberCtrl.$setViewValue(undefined);
                            this.paymentForm.cardNumber.$setValidity('wrongCreditCardNumber', false);
                        });
                } else {
                    $scope.ngModelCardNumberCtrl.$setViewValue(undefined);
                    this.paymentForm.cardNumber.$setValidity('wrongCreditCardNumber', false);
                }
            });
        }
    }

    angular.module('ekh')
        .directive('validateCardType', () => {
            return {
                restrict: 'A',
                require: 'ngModel',
                controllerAs: 'validateCtrl',
                bindToController: {
                    paymentForm: '=',
                    cardNumber: '=ngModel',
                    paymentOptions: '=',
                    maskModel: '=',
                    cardType: '='
                },
                controller: ValidateCardType,
                template: '',
                link: ($scope, $element, $attrs, ngModelCtrl) => {
                    $scope.ngModelCardNumberCtrl = ngModelCtrl;
                }
            };
        });
};
